export default __webpack_public_path__ + "static/sirak-76de2bf0e56d4036925ddca335699a71.png";